import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAdmin } from "./AdminLayout";
import { useAdminLang } from "./adminLang";

const Audit = () => {
  const { isSuper } = useAdmin();
  const { tr, lang } = useAdminLang();
  const [tab, setTab] = useState("audit");
  const [logs, setLogs] = useState([]);
  const [outbox, setOutbox] = useState([]);

  useEffect(() => {
    if (isSuper) api.get("/admin/audit-logs").then((r) => setLogs(r.data)).catch(() => {});
    api.get("/admin/outbox").then((r) => setOutbox(r.data)).catch(() => {});
  }, [isSuper]);

  return (
    <div data-testid="admin-audit-page">
      <h1 className="text-2xl font-black text-white">{tr("Audit & e-mails", "Audit & emails")}</h1>
      <div className="mt-6 flex gap-2">
        <button onClick={() => setTab("audit")} data-testid="tab-audit"
          className={`text-xs font-bold rounded-full px-4 py-2 transition-colors ${tab === "audit" ? "bg-[#FF6600] text-[#08090A]" : "text-white/60 border border-white/15"}`}>{tr("Journal d'audit", "Audit log")}</button>
        <button onClick={() => setTab("outbox")} data-testid="tab-outbox"
          className={`text-xs font-bold rounded-full px-4 py-2 transition-colors ${tab === "outbox" ? "bg-[#FF6600] text-[#08090A]" : "text-white/60 border border-white/15"}`}>{tr("Boîte d'envoi", "Outbox")}</button>
      </div>

      {tab === "audit" && (
        <div className="mt-6 bg-[#101214] border border-white/10 rounded-2xl divide-y divide-white/5" data-testid="audit-log-list">
          {!isSuper && <p className="px-6 py-10 text-center text-white/35 text-sm">{tr("Réservé au super administrateur.", "Restricted to super administrator.")}</p>}
          {isSuper && logs.length === 0 && <p className="px-6 py-10 text-center text-white/35 text-sm">{tr("Aucune entrée.", "No entries.")}</p>}
          {isSuper && logs.map((l) => (
            <div key={l.id} className="px-5 py-3.5 text-xs">
              <span className="text-[#FF9900] font-bold">{l.action}</span>
              <span className="text-white/60"> {l.entity} {l.entity_id && `#${l.entity_id.slice(0, 8)}`}</span>
              <span className="text-white/35"> — {l.user_email} · {new Date(l.created_at).toLocaleString(lang === "en" ? "en-GB" : "fr-FR")}</span>
            </div>
          ))}
        </div>
      )}

      {tab === "outbox" && (
        <div className="mt-6 bg-[#101214] border border-white/10 rounded-2xl divide-y divide-white/5" data-testid="outbox-list">
          {outbox.length === 0 && <p className="px-6 py-10 text-center text-white/35 text-sm">{tr("Aucun e-mail.", "No emails.")}</p>}
          {outbox.map((m) => (
            <div key={m.id} className="px-5 py-4">
              <div className="flex items-center justify-between gap-3">
                <p className="text-sm font-bold text-white truncate">{m.subject}</p>
                <span className={`text-[10px] font-black uppercase tracking-wider rounded-full px-2.5 py-1 ${m.status === "sent" ? "bg-green-500/15 text-green-400" : m.status === "failed" ? "bg-red-500/15 text-red-400" : "bg-[#FFC000]/15 text-[#FFC000]"}`}>
                  {m.status === "sent" ? tr("Envoyé", "Sent") : m.status === "failed" ? tr("Échec", "Failed") : tr("Journalisé (SMTP non configuré)", "Logged (SMTP not configured)")}
                </span>
              </div>
              <p className="mt-1 text-xs text-white/40">{tr("À", "To")} : {m.recipient} · {new Date(m.created_at).toLocaleString(lang === "en" ? "en-GB" : "fr-FR")}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Audit;
